import type { OngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import { invariant } from '@mimir/common/util/invariant';
import { assert } from 'chai';
import { deliverPremiereItemUpdate } from './deliverPremiereItemUpdate';
import type { ProjectItemUpdate } from '@mimir/primitive/premiere/premiereUpdate';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';

export async function updateExistingClip(
  adobeContext: AdobePanelContext | ElectronContext,
  ongoingDownload: OngoingDownload,
  locallyAvailablePath: string,
) {
  const deliverArr = ongoingDownload.deliver;
  assert(deliverArr, 'Bad assumption. Not all completed downloads appear to have delivery strategies.');
  const premiereItemUpdateDeliverArr = (deliverArr ?? []).filter(d => d.type === 'DeliverPremiereItemUpdate');
  if (premiereItemUpdateDeliverArr.length > 0) {
    for (const deliver of premiereItemUpdateDeliverArr) {
      await deliverPremiereItemUpdate(adobeContext, ongoingDownload, deliver, locallyAvailablePath);
    }
    return;
  }

  const itemId = ongoingDownload.itemId;
  invariant(itemId, 'Expected itemId in updateExistingClip');
  const artefact = ongoingDownload.artefact;
  invariant(artefact !== undefined, 'Expected artefact in updateExistingClip');
  const cepb = adobeContext.cepBridgeClient;
  const projectItemInfos = await cepb.call('getAllProjectItemInfos');
  for (const projectItemInfo of projectItemInfos) {
    if (projectItemInfo.meta['Mimir.Item.Id'] !== itemId) {
      continue;
    }
    const update : ProjectItemUpdate = { meta: { } };
    if (artefact === 'proxy') {
      update.proxyMediaPath = locallyAvailablePath;
    }
    if (artefact === 'highres') {
      update.hiresMediaPath = locallyAvailablePath;
    }
    await cepb.call('updateProjectItem', projectItemInfo.ref, update);
  }
}
